import { Link } from "react-router-dom";
const FooterMain2 = () => {
    return(
       <div className="mt-12 pl-6 mb-7 w-[100%] md:w-full md:px-8">
            <div className="mb-7">
                <p className="text-nextColor font-IRANYekanExtra text-[20px] text-center md:text-center">
                    لینک های کاربردی   
                </p>
            </div>
            <div className="flex justify-center items-center md:justify-center">
                <div className="flex flex-col  md:ml-0 align-middle items-center">
                    <Link to={"/about-us"} className="cursor-pointer mb-3 text-white font-IRANYekanMedium text-[15px] md:text-[10px]">
                      
                            درباره ما      
                        
                    </Link>
                    <Link to={"/contact-us"} className="cursor-pointer mb-3 text-white font-IRANYekanMedium text-[15px] md:text-[10px]">
                    
                            تماس با ما      
                     
                    </Link>
                    <Link to={"archive/all"} className="cursor-pointer mb-3 text-white font-IRANYekanMedium text-[15px] md:text-[10px]">
                         آخرین اخبار   
                      
                    </Link>
                   
                </div>
            
                {/* <div className="flex flex-col ">
                    <a href="/" className="cursor-pointer mb-3">
                    <p className="text-white font-IRANYekanMedium text-[15px]">
                            درباره ما      
                        </p>
                    </a>
                    <a href="/" className="cursor-pointer mb-3">
                    <p className="text-white font-IRANYekanMedium text-[15px]">
                            تماس با ما      
                        </p>
                    </a>
                    <a href="/" className="cursor-pointer mb-3">
                    <p className="text-white font-IRANYekanMedium text-[15px]">
                            درباره ما      
                        </p>
                    </a>
                    <a href="/" className="cursor-pointer mb-3">
                    <p className="text-white font-IRANYekanMedium text-[15px]">
                            تماس با ما      
                        </p>
                    </a>
                    <a href="/" className="cursor-pointer mb-3">
                    <p className="text-white font-IRANYekanMedium text-[15px]">
                            درباره ما      
                        </p>
                    </a>
                    <a href="/" className="cursor-pointer mb-3">
                    <p className="text-white font-IRANYekanMedium text-[15px]">
                            تماس با ما      
                        </p>
                    </a>
                </div> */}

            </div>

       </div>
    )
}

export default FooterMain2;